import { requestPasswordResetApiV1AuthPasswordResetRequestPost } from '@/common/api/client/sdk.gen'
import type {
    RequestPasswordResetApiV1AuthPasswordResetRequestPostData,
    RequestPasswordResetApiV1AuthPasswordResetRequestPostError,
    RequestPasswordResetApiV1AuthPasswordResetRequestPostResponse,
} from '@/common/api/client/types.gen'
import { useFormMutation } from '@/common/hooks/useFormMutation'

export const useRecovery = () => {
    const { mutation, onSubmit, register, handleSubmit, errors } = useFormMutation<
        RequestPasswordResetApiV1AuthPasswordResetRequestPostData['body'],
        RequestPasswordResetApiV1AuthPasswordResetRequestPostResponse,
        RequestPasswordResetApiV1AuthPasswordResetRequestPostError
    >({
        mutationFn: data => requestPasswordResetApiV1AuthPasswordResetRequestPost({ body: data }).then(r => r.data!),
        toastOptions: {
            successMessage: data => data.message,
        },
    })

    return {
        register,
        handleSubmit,
        errors,
        onSubmit,
        mutation,
    }
}
